import { NormalizeSlugs } from "./helper-functions";

export const resolveFeatureDefinitionTypeFromProduct = (product = {}) => {
  const category = NormalizeSlugs(product.categoryEN || product.category || "");
  const subcategory = NormalizeSlugs(product.subcategoryEN || product.subcategory || "");

  if (category === "cooking") {
    if (subcategory.includes("microwave")) return "Microwave";
    return "Range";
  }

  if (category === "refrigeration") {
    return "Refrigeration";
  }

  if (category === "dishwasher") {
    return "Dishwasher";
  }

  if (category === "laundry") {
    if (
      subcategory.includes("front-load") ||
      subcategory.includes("washtower")
    ) {
      return "Front Load Washers";
    }

    if (subcategory.includes("top-load")) {
      return "Top Load Washers";
    }

    if (
      subcategory.includes("dryer") ||
      subcategory.includes("dryers")
    ) {
      return "Front Load Dryers";
    }

    if (subcategory.includes("styler")) {
      return "Styler";
    }
  }

  return null;
};